export const GRADIENTS = [
  'linear-gradient(135deg, #7db8d4, #5a9bb8)',
  'linear-gradient(135deg, #8b9bc7, #6b7db0)',
  'linear-gradient(135deg, #7bbf9c, #5a9e7d)',
  'linear-gradient(135deg, #d4b87a, #b89c5e)',
  'linear-gradient(135deg, #c9a07a, #ad8660)',
  'linear-gradient(135deg, #c49aac, #a87d92)',
  'linear-gradient(135deg, #bf8a8a, #a37070)',
  'linear-gradient(135deg, #9a8fbe, #7d74a1)',
  'linear-gradient(135deg, #a08ec4, #8472a8)',
  'linear-gradient(135deg, #7db8ad, #5f9c92)',
  'linear-gradient(135deg, #8e9baa, #6e7d8c)',
  'linear-gradient(135deg, #4a5568, #2d3748)',
];

export const DEFAULT_GRADIENT = 'linear-gradient(135deg, #7db8d4, #5a9bb8)';

export function emojiToTwemojiUrl(emoji: string): string {
  const codepoints = [...emoji]
    .map((c) => c.codePointAt(0)!.toString(16))
    .filter((cp) => cp !== 'fe0f')
    .join('-');
  return `/twemoji/${codepoints}.svg`;
}

export const EMOJI_PALETTE: { label: string; emojis: string[] }[] = [
  { label: '常用', emojis: ['😀', '🤖', '💬', '📝', '📊', '🔍', '✅', '❌', '⚡', '🔥', '💡', '🎯'] },
  { label: '办公', emojis: ['📋', '📁', '📂', '💼', '📈', '📉', '📊', '🗂️', '📌', '📎', '✏️', '🖊️'] },
  { label: '工具', emojis: ['🔧', '🔨', '⚙️', '🛠️', '🔩', '🔑', '🔒', '🔓', '🧰', '💻', '🖥️', '📱'] },
  { label: '自然', emojis: ['☀️', '🌙', '⭐', '🌈', '🌊', '🌿', '🍀', '🌸', '🌺', '🔥', '💧', '🌍'] },
  { label: '动物', emojis: ['🐱', '🐶', '🐻', '🦊', '🐼', '🦁', '🐯', '🐸', '🦋', '🐝', '🐢', '🐙'] },
  { label: '食物', emojis: ['🍎', '🍊', '🍋', '🍇', '🍓', '🍕', '🍔', '🍩', '🎂', '☕', '🍵', '🧃'] },
];
